import usePrescriptionResultPDFFragment from './usePrescriptionPDFFragment.hook';

export default usePrescriptionResultPDFFragment;
